module.exports = __webpack_public_path__ + "img/猫耳朵.224879b1.png";